import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { filter, map } from 'rxjs/operators';

interface CustomEvent {
  name: string;
  payload: any;
}

@Injectable({
  providedIn: 'root',
})
export class EventService {
  private recordUpdatedSource = new Subject<any>(); // Puedes reemplazar "any" por un tipo concreto
  private eventSource = new Subject<CustomEvent>();

  recordUpdated$ = this.recordUpdatedSource.asObservable();

  emitRecordUpdated(updatedRecord: any) {
    this.recordUpdatedSource.next(updatedRecord);
  }

  // Emitir evento personalizado
  emitEvent(name: string, payload: any): void {
    this.eventSource.next({ name, payload });
  }

  // Suscribirse a evento por nombre
  onEvent<T = any>(name: string): Observable<T> {
    return this.eventSource.asObservable().pipe(
      filter(event => event.name === name),
      map(event => event.payload as T)
    );
  }
}